import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { SHARED_MODULES } from '@app/shared';

@Component({
  selector: 'app-posts-jumbotron',
  standalone: true,
  imports: [SHARED_MODULES],
  templateUrl: './post-jumbotron.component.html',
  host: { class: 'flex h-full min-h-64 w-full flex-col items-center justify-center rounded-2xl bg-transparent p-8' },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PostJumbotronComponent {
  @Input() public showIcon = true;
  @Input() public icon = '';
  @Input() public title = '';
  @Input() public description = '';
}
